import { render, staticRenderFns } from "./VoucherRegionTableComponent.vue?vue&type=template&id=a2420f2a"
import script from "./VoucherRegionTableComponent.vue?vue&type=script&lang=js"
export * from "./VoucherRegionTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports